import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { UsersFilter } from './UsersFilter';
export const projectOwnerFilterLabel = () => t({ message: 'Project owner', comment: 'Insights filter: Project owner' });
export const ProjectOwnerFilter = withFilterErrorBoundary(() => (<UsersFilter name="metadataProjectProjectOwner" label={projectOwnerFilterLabel()}/>));
